import { LocationQuery } from 'vue-router';
import { http } from '../helpers/axiosHelper';
export default class CustomerService {
   async getCustomers(query: LocationQuery) {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/customer', { params: query }).then((response) => {
         return response.data;
      });
   }

   async createCustomer(body: any) {
      return await http.post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/customer', body).then((response) => {
         return response.data;
      });
   }

   async editCustomer(id: Number, body: any) {
      return await http.put(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/customer/' + id, body).then((response) => {
         return response.data;
      });
   }
}
